import { createUseStyles } from 'react-jss'

export const style = {
  svg: {
    display: 'block',
    overflow: 'visible',

    // override normalize defaults for embedded content
    '&:not(:root)': {
      overflow: 'visible'
    }
  },
  sankeyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}

export const useStyles = createUseStyles(style)
